import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState, useEffect, useLayoutEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDebounce } from 'react-use';
import { Helmet } from 'react-helmet-async';
import { CYLINDO_ACCOUNT_ID } from 'commons/constants';
import usePdpId from '../state/context/usePdpId';
const SCRIPT_ID = 'cylindoScript';
const loadCylindo = callback => {
  const existingScript = document.getElementById(SCRIPT_ID);
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = 'https://viewer-cdn.cylindo.com/v1/index.mjs';
    script.id = SCRIPT_ID;
    script.type = 'module';
    script.async = true;
    document.body.appendChild(script);
    script.onload = () => {
      if (callback) callback();
    };
  } else if (callback) {
    callback();
  }
};
const PDPCylindo3dViewer = t0 => {
  const $ = _c(33);
  const {
    containerId: t1,
    cylindoFeatures,
    isMobile,
    rotateIndex
  } = t0;
  const containerId = t1 === undefined ? "PDPCylindo3dViewer" : t1;
  const containerRef = useRef(null);
  const [isReady, setIsReady] = useState(false);
  const controls = isMobile ? "ar" : "ar zoom";
  const productId = usePdpId();
  let t2;
  if ($[0] !== cylindoFeatures || $[1] !== productId) {
    t2 = () => {
      if (productId && Object.keys(cylindoFeatures).length > 0) {
        loadCylindo(() => {
          setIsReady(true);
        });
      }
    };
    $[0] = cylindoFeatures;
    $[1] = productId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cylindoFeatures || $[4] !== productId) {
    t3 = [productId, cylindoFeatures];
    $[3] = cylindoFeatures;
    $[4] = productId;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useDebounce(t2, 100, t3);
  let t4;
  let t5;
  if ($[6] !== containerId || $[7] !== isMobile || $[8] !== isReady || $[9] !== rotateIndex) {
    t4 = () => {
      if (!isMobile && containerRef.current && rotateIndex >= 0 && isReady) {
        const viewer = document.querySelector(`cylindo-viewer#${containerId}`);
        if (viewer && typeof viewer.animateToFrame === "function") {
          if (rotateIndex === 0) {
            viewer.animateToFrame(1);
          } else {
            if (rotateIndex === 1) {
              viewer.animateToFrame(4);
            } else {
              if (rotateIndex === 2) {
                viewer.animateToFrame(9);
              } else {
                if (rotateIndex === 3) {
                  viewer.animateToFrame(14);
                } else {
                  if (rotateIndex === 4) {
                    viewer.animateToFrame(17);
                  }
                }
              }
            }
          }
        }
      }
    };
    t5 = [containerRef, isMobile, rotateIndex, isReady, containerId];
    $[6] = containerId;
    $[7] = isMobile;
    $[8] = isReady;
    $[9] = rotateIndex;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[12] !== cylindoFeatures || $[13] !== isReady) {
    t6 = () => {
      if (containerRef.current && Object.keys(cylindoFeatures).length && isReady) {
        containerRef.current.features = cylindoFeatures;
      }
    };
    t7 = [containerRef, cylindoFeatures, isReady];
    $[12] = cylindoFeatures;
    $[13] = isReady;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useLayoutEffect(t6, t7);
  let t8;
  bb0: {
    if (!Object.keys(cylindoFeatures).length) {
      t8 = null;
      break bb0;
    }
    let t9;
    if ($[16] !== cylindoFeatures) {
      t9 = Object.entries(cylindoFeatures).reduce(_temp, []).join("&");
      $[16] = cylindoFeatures;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    t8 = t9;
  }
  const featuresParam = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [];
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  useLayoutEffect(_temp2, t9);
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Helmet><link rel="preconnect" href="https://content.cylindo.com" /></Helmet>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== productId) {
    t11 = productId?.toString();
    $[20] = productId;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== productId) {
    t12 = productId?.toString();
    $[22] = productId;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== productId) {
    t13 = productId?.toString();
    $[24] = productId;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = `https://content.cylindo.com/api/v2/${CYLINDO_ACCOUNT_ID}/products/${t12}/frames/1/${t13}.webp?encoding=webp-100&size=1024&${featuresParam}`;
  let t15;
  if ($[26] !== t14) {
    t15 = <img slot="placeholder" alt="placeholder" src={t14} />;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== containerId || $[29] !== controls || $[30] !== t11 || $[31] !== t15) {
    t16 = <>{t10}<div className="w-full !h-full ml-auto mr-auto max-md:min-h-[375px] flex justify-center items-center [&_img]:w-4/5 lg:[&_cylindo-viewer]:aspect-[1.8]" data-xc="PDPCylindo3dViewerContainer"><cylindo-viewer controls={controls} ref={containerRef} key={containerId} customer-id={CYLINDO_ACCOUNT_ID} code={t11} id={containerId} data-xc="PDPCylindo3dViewer">{t15}</cylindo-viewer></div></>;
    $[28] = containerId;
    $[29] = controls;
    $[30] = t11;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  return t16;
};
PDPCylindo3dViewer.propTypes = {
  containerId: PropTypes.string,
  cylindoFeatures: PropTypes.arrayOf(PropTypes.string),
  isMobile: PropTypes.bool,
  rotateIndex: PropTypes.number
};
export default PDPCylindo3dViewer;
function _temp(acc, t0) {
  const [key, value] = t0;
  const cleanValue = value.replace(/ /g, "%20");
  return [...acc, `feature=${key}:${cleanValue}`];
}
function _temp2() {
  const viewer_0 = document.querySelector("cylindo-viewer");
  viewer_0?.addEventListener("loaded", () => {
    const {
      modelViewer
    } = viewer_0;
    if (modelViewer) {
      modelViewer.exposure = 0.9;
    }
  });
}